// src/layouts/Layout.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const noFooterRoutes = ['/login', '/signup'];

  const showFooter = !noFooterRoutes.includes(location.pathname);

  return (
    <div className="font-poppins">
      <Navbar />
      <main>{children}</main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
